const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h600v300H0z",
    style: {
      fill: "#cf142b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.102 546.464c.291-.879.877-9.946.584-9.946-.293 0-13.747-15.793-13.454-15.793.294 0 17.257 3.803 17.257 3.216 0-.583 6.727-16.67 6.727-16.963 0-.291 8.19 19.597 8.19 19.597l16.67 7.313-11.7 9.65s2.634 18.72 2.634 19.013c0 .291-11.7-11.116-11.7-11.116l-12.87 1.463s-1.754-5.85-2.338-6.434z",
    style: {
      fontSize: 12,
      fill: "#f9dd16",
      fillOpacity: 0.98823499,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "2.40245399pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.48 300.674c-11.114 5.723-53.768 54.478-59.618 62.082-4.9 11.04-14.486 25.005-24.36 33.995-10.54 7.973-16.397 18.866-14.946 29.18-.118 12.834 7.078 21.572 12.81 30.602 3.392 4.125 7.957 6.792 12.81 7.116 9.955 1.315 10.84 4.38 15.822 6.278 19.628 26.725 48.91 46.432 69.998 62.043 13.442 7.085 22.79 14.17 25.992 18.038 6.175 11.789 5.038 23.285 4.193 28.933-5.219 19.69-10.439 39.38-15.657 59.071-2.633 16.087 11.347 12.47 12.099 9.252 6.308-8.19 15.724-2.438 29.177-49.82 6.167-8.302 12.337-16.605 18.504-24.908 0 0 7.119-2.847 7.119-3.558 10.823-12.995 2.582-20.433-3.56-22.773-4.508-1.66-9.015-3.323-13.522-4.983 0 0-15.657-15.657-16.368-15.657-7.44-21.643-43.96-67.85-52.443-74.283-5.872-6.12-8.666-8.726-14.24-12.13-8.569-4.099-11.334-5.432-16.583-7.527-4.37-1.754-1.26-6.552 1.52-8.745 28.926-15.746 51.855-33.245 79.61-51.038l4.27-2.847-9.963-56.933c-15.42-5.456-30.84-10.915-46.26-16.37-2.426 1.66-4.269 3.322-6.405 4.982z",
    style: {
      fontSize: 12,
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 3.71638179,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.185 600.428c.147-.583 28.955-5.85 28.955-5.85s-3.364 10.677-3.51 10.677l-28.662 8.627 3.217-13.454z",
    style: {
      fontSize: 12,
      fill: "#f9dd16",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: "1pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.113 491.958c5.557-14.77 20.983-26.466 31.345-29.692",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.40245399pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.15 600.688c1.86-.524 10.117-2.934 12.521-3.308 2.566-.601 5.12-1.274 7.587-2.069 2.847-.581 4.63-1.117 7.587-1.655 2.316-.884 4.606-1.49 7.083-2.069M360.934 618.5c.24-.322 2.203-2.057 3.613-2.895 1.66-.524 7.338-2.934 9.485-3.309 2.292-.6 4.572-1.273 6.775-2.068 2.544-.581 4.135-1.117 6.778-1.655 2.068-.884 4.113-1.49 6.323-2.069",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.65663357pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.632 496.138h-.414c1.295 0 .5-.108-1.242 2.068-.62 1.672-5.929 5.377-9.927 5.377-1.929.207-4.893.413-6.825.413-.55 0-1.31-.413-1.862-.413M372.218 581.348h2.067c2.145 0 4.298.382 6.205.413 2.069 0 4.137.586 6.206.586 2.087.296 4.603.2 6.763.507 2.421.082 4.365.56 6.885.56 2.032.077 3.128.416 5.38.416l-5.38-.416c2.032.077 3.128.416 5.38.416M358.155 631.81c.22-.323 2.018-2.057 3.308-2.896 1.52-.523 6.72-2.933 8.687-3.308 2.097-.6 4.185-1.273 6.203-2.068 2.33-.582 3.786-1.118 6.206-1.656 1.895-.884 3.767-1.49 5.79-2.068M396.89 559.913c-1.17 3.397.345 4.25.972 5.716 1.091 1.42 3.875 3.584 8.274 4.963 1.696.457 3.001.904 4.964 1.656 1.3.12 1.939.444 2.895.826M233.237 435.334h.413c-1.298 0-.52.084 1.655-1.655 1.343-1.502 2.465-2.182 3.721-3.722M260.02 464.8c.275 0 24.062-11.988 26.601-14.55 1.8-1.304 3.162-2.68 5.35-4.163 1.404-.732 2.41-1.672 3.725-2.481 1.093-1.583 2.52-2.54 3.308-3.988 1.46-1.266.833-2.638 2.018-4.164.56-1.561 1.607-4.192 1.948-5.622M333.265 447.623c.13.855-.38 3.49-.343 5.496-.082 2.326-3.073 9.51-6.689 11.655",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.40245399pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.53 447.356c.14 0 3.76 1.177 9.812 3.04 7.284 2.618 22.434 12.165 23.938 13.48 1.535 1.208 4.281 2.286 5.333 3.72 1.646 1.423 2.852 3.064 4.137 4.55 1.512 1.844 2.8 3.403 3.722 4.964 4.6 3.731 16.976 29.565 17.372 31.023a63.455 63.455 0 0 1 2.068 4.55c.918 1.058 1.54 2.552 2.482 4.138.865 2.056 1.833 2.993 2.898 4.55 1.369.951 3.214 2.758 4.963 3.721 1.864 1.595 3.613 2.244 4.963 3.31 1.951.83 23.751 14.61 24.763 15.3 1.991 1.6 8.072 7.901 3.803 12.485-1.812 1.55-3.443 3.601-4.99 4.478-1.576 1.579-3.77 2.285-5.581 3.102-9.821 2.902-14.823 1.862-16.755 1.862h-2.068M242.383 398.622c2.791 1.093 1.665.286 4.178 1.43 1.688.74 2.8.759 4.46 1.364 1.762.565 6.682 1.451 9.046 3.825 1.735 1.566 3.058 2.89 4.964 4.034 2.253 1.554 3.88 2.246 6.674 3.411 2.356.882 4.992 1.86 7.375 1.944 2.477.144 3.07.021 5.446.021h5.793-5.793 5.793",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.40245399pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.717 426.234c6.203-.414 16.543 1.448 16.75 1.448l13.65-.206c7.172-.692 8.755-3.448 9.928-5.38 2.688-4.134 4.55-5.583 6.619-8.684 3.308-2.482 7.86 3.308 8.067 3.308 11.58 10.962 2.273 24.404 1.653 24.817-5.79 5.31-7.032 5.653-10.547 2.275-3.517-4.137-4.55-5.996-7.445-7.445-5.583-2.688-17.166-.62-17.375-.62-.206 0-5.996 2.275-5.996 2.275-2.828 1.034-4.62 3.518-9.514 4.342-4.963.346-6.619-.137-9.1-4.135-3.309-5.17-1.656-11.376 3.31-11.995z",
    style: {
      fontSize: 12,
      fill: "#ffe606",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "2.40245399pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.566 175.36c-.909.177-9.1 4.11-8.956 4.365.144.255-7.03 19.723-7.173 19.467-.144-.255-5.142-16.906-5.653-16.618-.51.286-17.828 2.306-18.084 2.45-.253.142 13.068-16.743 13.068-16.743l-1.795-18.116 14.146 5.469s15.027-11.47 15.283-11.613c.253-.143-3.956 15.646-3.956 15.646l7.583 10.502s-4.24 4.395-4.463 5.19z",
    style: {
      fontSize: 12,
      fill: "#f9dd16",
      fillOpacity: 0.98823499,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "2.40245457pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.73 374.811c10.435 6.883 73.838 20.169 83.333 21.542 12.025-1.139 28.896.373 41.571 4.574 12.116 5.28 24.481 5.046 32.76-1.273 11.245-6.187 15.335-16.741 20.398-26.164 1.933-4.979 2.02-10.264-.075-14.654-3.734-9.322-1.495-11.595-2.283-16.868 13.676-30.207 16.505-65.389 19.777-91.422-.412-15.19 1.182-26.81 2.985-31.497 7.25-11.16 17.827-15.803 23.165-17.834 19.721-5.101 39.443-10.2 59.164-15.302 15.313-5.589 5.308-16.002 2.135-15.08-10.23-1.486-9.831-12.512-57.726-1.018-10.26-1.307-20.52-2.616-30.78-3.922 0 0-5.97-4.81-6.59-4.461-16.632-3.066-19.077 7.762-18.106 14.264.762 4.742 1.521 9.486 2.283 14.228 0 0-5.974 21.32-5.626 21.94-15.22 17.093-37.876 71.981-39.327 82.529-.686 9.91-4.43 8.121-3.426 17.754.038 7.528-.838 2.828 1.675 18.338.613 4.669-5.094 4.308-8.368 2.96-27.9-17.497-54.392-28.907-83.504-44.381l-4.574-2.326-44.744 36.586 8.401 48.346c2.636 1.302 4.989 2.093 7.482 3.141z",
    style: {
      fontSize: 12,
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 3.71638179,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.05 194.167c-.582.158-19.29-22.372-19.29-22.372s10.955-2.3 11.026-2.173l21.567 20.756-13.304 3.79z",
    style: {
      fontSize: 12,
      fill: "#f9dd16",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: "1pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.29 312.765c-15.599 2.395-33.353-5.32-41.244-12.77",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.40245457pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.783 194.943c-1.368-1.365-7.515-7.381-9.02-9.294-1.782-1.942-3.62-3.839-5.522-5.6-1.902-2.196-3.242-3.487-5.161-5.802-1.906-1.585-3.555-3.284-5.274-5.16m43.059 21.673c-.398-.052-2.872-.913-4.294-1.731-1.27-1.19-6.153-4.958-7.532-6.647-1.647-1.703-3.35-3.36-5.124-4.891-1.753-1.933-3-3.057-4.764-5.097-1.784-1.37-3.314-2.855-4.902-4.498",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.65663414pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m544.473 240.531.202.36c-.634-1.129-.339-.382 2.412.07 1.761-.28 7.592 2.532 9.552 6.017 1.125 1.58 2.758 4.063 3.705 5.747.27.48.281 1.344.552 1.826M618.95 199.13l-.202-.36-.81-1.44c-1.051-1.87-1.773-3.934-2.68-5.612-1.015-1.803-1.517-3.893-2.531-5.696-.766-1.965-2.082-4.11-2.873-6.144-1.115-2.15-1.651-4.08-2.886-6.276-.93-1.81-1.17-2.93-2.274-4.893l2.274 4.893c-.93-1.81-1.17-2.93-2.274-4.893M669.829 186.66c-.389-.035-2.782-.752-4.145-1.465-1.202-1.07-5.85-4.42-7.141-5.951-1.551-1.534-3.16-3.024-4.843-4.394-1.649-1.746-2.83-2.753-4.484-4.598-1.7-1.219-3.145-2.553-4.64-4.033M588.176 188.13c3.534-.644 3.535-2.384 4.505-3.648.703-1.647 1.225-5.135.271-9.645-.433-1.702-.683-3.059-.99-5.138-.531-1.192-.562-1.908-.698-2.929M559.787 391.837l-.202-.36c.636 1.13.327.411-2.254-.632-1.967-.434-3.11-1.08-5.068-1.42M572.346 354.05c-.135-.24-22.242-15.1-25.72-16.058-2.018-.929-3.886-1.442-6.25-2.623-1.327-.864-2.64-1.28-3.989-2.03-1.916-.176-3.448-.952-5.097-.929-1.82-.652-2.708.566-4.619.282-1.635.277-4.442.653-5.855 1.056M521.476 298.622c.682-.532 3.23-1.38 4.96-2.394 2.067-1.069 9.795-1.982 13.437.119",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.40245457pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.188 336.004c-.069-.121-.817-3.854-2.16-10.042-1.287-7.633-.39-25.518.019-27.473.3-1.93-.105-4.852.63-6.472.433-2.132 1.272-3.987 1.939-5.837.865-2.22 1.593-4.106 2.502-5.676.998-5.839 17.451-29.286 18.528-30.347a63.46 63.46 0 0 1 2.953-4.033c.472-1.318 1.47-2.593 2.39-4.19 1.368-1.762 1.71-3.065 2.546-4.756.158-1.66.829-4.154.811-6.15.477-2.407.186-4.25.454-5.95-.234-2.106 1.094-27.862 1.2-29.082.418-2.52 2.931-10.909 9.02-9.434 2.238.82 4.826 1.236 6.348 2.155 2.148.6 3.84 2.166 5.439 3.345 7.343 7.138 8.887 12.008 9.834 13.692l1.014 1.803M523.194 401.023l-.203-.36c.548.974.244.488-.45-1.645-.184-1.835-.75-4.317-1.035-6.061-.371-1.812-1.22-3.876-.99-5.138-.649-1.84-.24-3.36-.067-5.183.516-2.28.748-3.929.812-6.15.25-2.726.049-4.658.204-7.234-.718-2.12-.865-3.896-1.96-6.015-.973-2.026-1.718-3.9-2.883-5.972l-2.839-5.049 2.84 5.05-2.84-5.05",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.40245457pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.698 388.905c-3.4-5.205-6.845-15.13-6.946-15.31 0-.003-6.87-11.798-6.87-11.798-4.118-5.912-7.296-5.942-9.554-6.017-4.921-.317-7.097-1.23-10.814-1.513-3.785-1.668-.969-8.474-1.07-8.654 3.88-15.466 20.159-13.94 20.823-13.603 7.465 2.445 8.373 3.36 7.152 8.078-1.883 5.094-2.997 6.905-2.841 10.139.392 6.184 7.872 15.266 7.974 15.449.102.18 4.922 4.112 4.922 4.112 2.287 1.958 5.33 2.303 8.447 6.165 2.734 4.157 3.124 5.836.856 9.959-2.885 5.417-9.105 7.018-12.079 2.993z",
    style: {
      fontSize: 12,
      fill: "#f9dd16",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "2.40245457pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.862 224.504c.121-.366.365-4.14.243-4.14s-5.722-6.574-5.6-6.574c.122 0 7.183 1.583 7.183 1.339 0-.243 2.8-6.939 2.8-7.061 0-.121 3.409 8.157 3.409 8.157l6.939 3.044-4.87 4.017s1.096 7.792 1.096 7.914c0 .121-4.87-4.627-4.87-4.627l-5.357.609s-.73-2.435-.973-2.678z",
    style: {
      fill: "#f9dd16",
      fillOpacity: 0.98823499,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.141 122.196c-4.626 2.382-22.38 22.676-24.815 25.841-2.04 4.595-6.03 10.408-10.14 14.15-4.387 3.319-6.825 7.853-6.221 12.146-.049 5.342 2.946 8.979 5.332 12.738 1.412 1.717 3.312 2.827 5.332 2.962 4.144.547 4.512 1.823 6.586 2.613 8.17 11.124 20.358 19.327 29.136 25.825 5.595 2.949 9.486 5.898 10.819 7.508 2.57 4.907 2.097 9.692 1.745 12.043l-6.517 24.588c-1.096 6.696 4.723 5.19 5.036 3.851 2.626-3.409 6.545-1.015 12.145-20.737l7.702-10.368s2.963-1.185 2.963-1.481c4.505-5.409 1.075-8.505-1.482-9.479l-5.628-2.074s-6.517-6.517-6.813-6.517c-3.097-9.009-18.39-28.426-21.921-31.104-3.456-2.271-2.043-3.264-5.743-4.865-2.739-1.522-.855-.881-6.995-3.133-1.819-.73-.524-2.727.633-3.64 12.04-6.554 21.584-13.838 33.137-21.244l1.777-1.185-4.147-23.698-19.255-6.814c-1.01.691-1.777 1.383-2.666 2.074z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.54691064,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    transform: "matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.252 246.966c.061-.243 12.052-2.435 12.052-2.435s-1.4 4.444-1.461 4.444l-11.93 3.591 1.339-5.6z",
    style: {
      fill: "#f9dd16",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.004 201.816c2.313-6.148 8.734-11.016 13.047-12.359",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1pt",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.821 247.074c.774-.218 4.211-1.221 5.212-1.377 1.068-.25 2.131-.53 3.158-.861 1.185-.242 1.927-.465 3.158-.689.964-.368 1.917-.62 2.948-.861m-16.647 11.202c.1-.134.917-.856 1.504-1.205.691-.218 3.054-1.221 3.948-1.377.954-.25 1.903-.53 2.82-.861 1.059-.242 1.721-.465 2.821-.689.861-.368 1.712-.62 2.632-.861",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.10579996pt"
    },
    transform: "matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.519 203.556h-.172c.539 0 .208-.045-.517.861-.258.696-2.468 2.238-4.132 2.238-.803.086-2.037.172-2.841.172-.229 0-.545-.172-.775-.172M219.347 239.024H220.207c.893 0 1.789.159 2.583.172.861 0 1.722.244 2.583.244.869.123 1.916.083 2.815.211 1.008.034 1.817.233 2.866.233.846.032 1.302.173 2.239.173l-2.239-.173c.846.032 1.302.173 2.239.173M213.493 260.028c.092-.134.84-.856 1.377-1.205.633-.218 2.797-1.221 3.616-1.377.873-.25 1.742-.53 2.582-.861.97-.242 1.576-.465 2.583-.689.789-.368 1.568-.62 2.41-.861M229.616 230.102c-.487 1.414.144 1.769.405 2.379.454.591 1.613 1.492 3.444 2.066.706.19 1.249.376 2.066.689.541.05.807.185 1.205.344M161.497 178.247h.172c-.54 0-.216.035.689-.689.559-.625 1.026-.908 1.549-1.549M172.645 190.512c.115 0 10.016-4.99 11.073-6.056.749-.543 1.316-1.116 2.227-1.733.584-.305 1.003-.696 1.55-1.033.455-.659 1.049-1.057 1.377-1.66.608-.527.347-1.098.84-1.733.233-.65.669-1.745.811-2.34M203.133 183.362c.054.356-.158 1.453-.143 2.288-.034.968-1.279 3.958-2.784 4.851",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1pt",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.345 183.251c.058 0 1.565.49 4.084 1.265 3.032 1.09 9.338 5.064 9.964 5.611.639.503 1.782.952 2.22 1.549.685.592 1.187 1.275 1.722 1.894.629.767 1.165 1.416 1.549 2.066 1.915 1.553 7.066 12.306 7.231 12.913.289.568.647 1.359.861 1.894.382.44.641 1.062 1.033 1.722.36.856.763 1.246 1.206 1.894.57.396 1.338 1.148 2.066 1.549.776.664 1.504.934 2.066 1.378.812.345 9.886 6.081 10.307 6.368.829.666 3.36 3.289 1.583 5.197-.754.645-1.433 1.499-2.077 1.864-.656.657-1.569.951-2.323 1.291-4.088 1.208-6.17.775-6.974.775h-.861M165.629 163.096h.172c-.465 0-.227-.011.689.172.703.308 1.719.609 2.41.861.733.235 1.655.348 2.066.689.8.14 1.268.598 1.894 1.033.722.652 1.273 1.073 2.066 1.549.938.647 1.68.968 2.583 1.55.916.172 1.59.481 2.582.516.934.06 1.766.172 2.755.172h2.411-2.411 2.411M221.241 142.952h-.345c.637 0 .458-.023-.516.172-1.017.525-2.371.922-3.272 1.377-1.028.34-2.133.717-3.099 1.206-1.094.641-2.102 1.162-3.099 1.893-.991.531-1.965 1.185-2.927 1.722-.959.521-1.751 1.024-2.582 1.722-.694.385-1.637.93-2.411 1.549-.727.261-1.252.779-1.721 1.206-.911.807-1.469 1.226-2.411 2.066-.495.468-1.153 1.018-1.894 1.721-.778.519-1.62 1.517-2.238 2.066-.396.517-.976 1.132-1.549 1.55-.441.555-.952 1.285-1.55 1.722-.355.528-.976 1.216-1.55 1.894-.465.569-1.105 1.142-1.549 1.721-.598.662-1.056 1.329-1.722 1.894-.119.398-.369.604-.516.861",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1pt",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.027 174.459c2.582-.172 6.886.603 6.972.603l5.682-.086c2.985-.288 3.644-1.435 4.132-2.239 1.119-1.721 1.894-2.324 2.755-3.615 1.377-1.033 3.272 1.377 3.358 1.377 4.82 4.563.946 10.158.688 10.33-2.41 2.21-2.927 2.353-4.39.947-1.464-1.722-1.894-2.496-3.099-3.099-2.324-1.119-7.145-.258-7.232-.258-.086 0-2.496.947-2.496.947-1.177.43-1.923 1.464-3.96 1.807-2.066.144-2.755-.057-3.788-1.721-1.377-2.152-.689-4.735 1.378-4.993z",
    style: {
      fill: "#f9dd16",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(-.38723 .74585 -.74585 -.38723 480.422 18.367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.302 290.148c-2.276-2.067 42.81 16.337 49.014 16.546 8.48-3.102 43.433-32.676 43.433-32.676.345 2.895 1.584 10.409 4.96 11.996-13.51 10.962-25.781 21.508-39.292 32.468.966 17.373-2.205 35.78 6.618 55.221 0 0-10.546.205-10.546 0-9.307-9.307-12.618-54.185-12.618-54.185-14.821-6.619-29.644-13.029-44.465-19.648 2.138-1.38 3.86-5.652 2.896-9.722z",
    style: {
      fontSize: 12,
      fill: "#f9dd16",
      fillOpacity: 0.98742095,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "2.40244999pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.199 336.153c.72-.523-8.133 4.113-10.407 5.277-40.961 21.85-62.04 53.634-63.354 54.835-.708 1.354-2.011 3.16-3.204 4.929-.96 1.483-2.338 3.018-3.246 4.518-1.255 1.738-3.893 5.17-5.334 6.694-.18.982.683-.336.4.317M403.187 310.185c-.795-.402 7.378 5.351 9.453 6.84 38.166 26.431 76.072 30.638 77.74 31.257 1.529.01 3.73.343 5.849.595 1.759.175 3.753.698 5.503.82 2.119.32 6.378 1.096 8.393 1.681.954-.29-.611-.453.098-.502",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.40244999pt"
    },
    transform: "matrix(.3498 0 0 .3498 163.243 23.834)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIm);
export default __webpack_public_path__ + "static/media/im.0d28983a9cee08fc1fed66ed6febc968.svg";
export { ForwardRef as ReactComponent };